import { useCallback, useState } from 'react'
import styled from 'styled-components'
import { formatAddress } from '@mysten/sui/utils'

import { Button } from 'components/Button/Button'
import { ViewAsWalletDialog } from './ViewAsWalletDialog'
import { useViewAsWallet } from 'contexts/ViewAsWalletContext'
import { Typography } from 'components/Typography/Typography'
import { IconEye } from 'components/Icons/IconEye'

const ViewAsWalletTrigger = styled.div`
  margin-left: 12px;
  padding: 11px 24px;
  border: 0.7px solid ${p => p.theme.colors.text.primary};
  border-radius: 100px;
  cursor: pointer;
  svg {
    margin-left: 10px;
  }

  transition: box-shadow 0.3s ease;
  &:hover {
    ${p => `box-shadow: 0 4px 10px ${p.theme.colors.button.outlinedBoxShadow};`}
  }
`

export const ViewAsWallet = () => {
  const [isOpenDialog, setIsOpenDialog] = useState(false)

  const { viewAsWalletAddress } = useViewAsWallet()

  const onOpenDialog = useCallback(() => setIsOpenDialog(true), [])

  const onCloseDialog = useCallback(() => setIsOpenDialog(false), [])

  return (
    <>
      {viewAsWalletAddress ? (
        <ViewAsWalletTrigger onClick={onOpenDialog}>
          <Typography variant="description" fontWeight="semiBold" style={{ display: 'flex', alignItems: 'center' }}>
            {formatAddress(viewAsWalletAddress)}
            <IconEye />
          </Typography>
        </ViewAsWalletTrigger>
      ) : (
        <Button style={{ marginLeft: 12 }} onClick={onOpenDialog}>
          View as wallet
        </Button>
      )}
      <ViewAsWalletDialog isOpen={isOpenDialog} onClose={onCloseDialog} />
    </>
  )
}
